import React, { useState } from "react";
import PreAuthCommunicationList from "./components/PreAuthCommunicationList";
import ClaimCommunicationList from "./components/ClaimCommunicationList";
import { useTranslation } from "react-i18next";
import "./styles/pre-auth.css";

function CommunicationsList(props) {
  const [totalList, setTotalList] = useState(0);
  const [activeTab, setActiveTab] = useState("preAuth");
  const { t } = useTranslation();

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  return (
    <>
      <div className="pre_auth_container !p-0">
        <div className="flex justify-between gap-1.5 flex-col sm:flex-row mb-2">
          <span className="font-semibold text-black/70 text-lg ">
            {t("Communications")}
            <span className=" text-lg ml-1">
              ({totalList || 0}{" "}
              <span className="text-xs font-bold italic">{t("Entries")}</span>)
            </span>
          </span>
        </div>
        <div className="my-2">
          <ul className="grid grid-flow-col text-center text-gray-500 bg-gray-100 rounded-lg p-1 shadow-inner">
            <li>
              <a
                className={`flex justify-center py-0.5 cursor-pointer hover:text-primary text-[13px] ${
                  activeTab === "preAuth"
                    ? "bg-[#0070C2] rounded-lg !text-white"
                    : ""
                }`}
                onClick={() => handleTabClick("preAuth")}
              >
                {t("Pre Authorization")}
              </a>
            </li>
            <li>
              <a
                className={`flex justify-center py-0.5 cursor-pointer hover:text-primary text-[13px] ${
                  activeTab === "claim"
                    ? "bg-[#0070C2] rounded-lg  !text-white"
                    : ""
                }`}
                onClick={() => handleTabClick("claim")}
              >
                {t("Claims")}
              </a>
            </li>
          </ul>
        </div>

        <div className="!mt-2">
          {activeTab === "preAuth" && (
            <PreAuthCommunicationList setTotslList={setTotalList} />
          )}
          {activeTab === "claim" && (
            <ClaimCommunicationList setTotslList={setTotalList} />
          )}
        </div>
      </div>
    </>
  );
}

export default CommunicationsList;
